import styled from 'styled-components';
import { ACCENT_COLOR, BTN, NAME_SECTION, PADDING, FONTSIZETITLE } from '../styles/style';

const Section = styled.div`
 background-color:#212529;
 padding: 30px 10px;
 color: #ffffff;
 text-align: center;
  
  @media(min-width:1024px){
margin-left: 15%;
  }
  .info-contact{
    color:#ffffff80;
    margin-top: 30px;
    font-size: .9rem;
  }
`

const Footer = () => {
  
  return (
    <Section id="footer">
    <div>Copyright © {new Date().getFullYear()} <span style={{color:ACCENT_COLOR}}>Wojciech Tałanda.</span> Wszystkie prawa zastrzeżone.</div>
  <div className="info-contact">
            <p>(+48) 504 705 724</p>
            <p>talanda.wojciech@gmail.com</p>
            <p>Rzeszów</p>
          </div>
    </Section>
  );
};

export default Footer;
